export function subscribeMiddleware(subscribe, unsubscribe, source) {
  return store => {
    initializePubSub(subscribe, unsubscribe, source, store);
    return next => action => next(action);
  };
}

function initializePubSub(subscribe, unsubscribe, source, store) {
  const handleEvent = event => {
    store.dispatch(event.data ? event.data : event);
  };
  subscribe(source, handleEvent);
}
